<div class="card">
  <div class="card-header">
    <h6 class="mb-0" i18n>Unit Specification</h6>
  </div>
  <div class="card-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2 class="mat-block" formGroupName="configuration">
            <app-select
              [items]="unitTypeOptions"
              [multiple]="false"
              [searchable]="true"
              bindLabel="unit_type_name"
              bindValue="unit_type_id"
              placeholder="Unit Type"
              i18n-placeholder
              [required]="true"
              formControlName="unit_type_id"
              (selectedChange)="onUnitTypeChange($event)"
            >
            </app-select>
            <mat-error
              *ngIf="
                configurationForm.get('unit_type_id')?.touched &&
                configurationForm.get('unit_type_id')?.hasError('required')
              "
            >
              <ng-container i18n>Unit Type is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <app-select
              [items]="unitNameOptions"
              [searchable]="true"
              [multiple]="false"
              bindLabel="unit_name"
              bindValue="unit_name_id"
              placeholder="Unit Name"
              i18n-placeholder
              [required]="true"
              formControlName="unit_name_id"
            >
            </app-select>
            <mat-error *ngIf="form.get('unit_name_id').touched && form.get('unit_name_id').hasError('required')">
              <ng-container i18n>Unit Name is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input
              type="number"
              matInput
              formControlName="number_of_units"
              placeholder="Number of Units"
              i18n-placeholder
            />
          </mat-form-field2>
        </div>
        <ng-container formGroupName="size">
          <div class="col-md-4">
            <mat-form-field2 class="mat-block">
              <input type="number" matInput formControlName="value" placeholder="Unit Size" i18n-placeholder required />
              <mat-select formControlName="unit" placeholder="Size Unit" i18n-placeholder required matSuffix>
                <mat-option *ngFor="let type of sizeOptions" [value]="type">{{ type | titleCase }}</mat-option>
              </mat-select>
              <mat-error *ngIf="sizeForm.get('value').touched && sizeForm.get('value').hasError('required')">
                <ng-container i18n>Unit Size is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </ng-container>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              matInput
              formControlName="floor_numbers_located_on"
              placeholder="Room Located on Floors"
              i18n-placeholder
            />
            <mat-hint i18n> Enter floor separated by comma </mat-hint>
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="smoking_policy" placeholder="Smoking Policy" i18n-placeholder>
              <mat-option *ngFor="let type of smokingOptions" [value]="type.value">
                {{ type.label }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </div>
      <hr />
      <h6>Occupancy Details</h6>
      <div class="row" formGroupName="occupancy">
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input type="number" matInput formControlName="max_guests" placeholder="Max Guests" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input type="number" matInput formControlName="max_adults" placeholder="Max Adults" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input type="number" matInput formControlName="max_children" placeholder="Max Children" i18n-placeholder />
          </mat-form-field2>
        </div>
      </div>
      <hr />
      <h6>Extra Beds Configuration</h6>
      <div class="row" formGroupName="extra_beds_configuration">
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input type="number" matInput formControlName="extra_beds" placeholder="Extra Beds" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block">
            <input type="number" matInput formControlName="cribs" placeholder="Cribs" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-checkbox formControlName="is_crib_and_extra_bed_allowed" style="margin-top: 2.25rem" i18n>
            Allow both Extra Bed and Cribs
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card mt-3">
  <div class="card-header">
    <h6 class="mb-0" i18n>Rooms</h6>
  </div>
  <div class="card-body">
    <form [formGroup]="form.get('configuration')">
      <div formArrayName="rooms" class="d-flex flex-column gap-3">
        <div
          class="p-3 border bg-default2 rounded"
          *ngFor="let room of roomsArray.controls; let ridx = index; let rcount = count"
        >
          <ng-container>
            <ng-template
              [ngTemplateOutlet]="multiRoomCfgTmpl"
              [ngTemplateOutletContext]="{ roomForm: room, index: ridx }"
              *ngIf="isMultiRoom"
            ></ng-template>
            <ng-template
              [ngTemplateOutlet]="monoRoomCfgTmpl"
              [ngTemplateOutletContext]="{ roomForm: room, index: ridx }"
              *ngIf="!isMultiRoom"
            ></ng-template>
          </ng-container>
        </div>
      </div>
      <div class="mt-3" *ngIf="isMultiRoom">
        <button class="btn btn-secondary-info" (click)="onAddRoom()">
          <i class="far fa-plus"></i>
          <ng-container i18n> Add Room </ng-container>
        </button>
      </div>
    </form>
  </div>
</div>

<ng-template #multiRoomCfgTmpl let-roomForm="roomForm" let-index="index">
  <ng-container [formGroup]="roomForm">
    <div class="d-flex gap-3">
      <mat-form-field2 class="mat-block">
        <mat-select
          formControlName="type"
          placeholder="Room Type"
          i18n-placeholder
          required
          (selectionChange)="onRoomTypeChange($event, roomForm)"
        >
          <mat-option *ngFor="let type of availableRoomTypeOptions" [value]="type">{{ type | titleCase }}</mat-option>
        </mat-select>
        <mat-error *ngIf="roomForm.get('type').touched && roomForm.get('type').hasError('required')">
          <ng-container i18n>Room Type is required</ng-container>
        </mat-error>
      </mat-form-field2>
      <button
        class="btn btn-secondary-danger align-input-row-end"
        (click)="onDeleteItem(roomsArray, index)"
        matTooltip="Delete this room"
        i18n-matTooltip
      >
        <i class="cs-icon cs-icon-trash"></i>
        <ng-container i18n> Delete Room </ng-container>
      </button>
    </div>
    <div formArrayName="bed_configurations" class="bg-white rounded border">
      <mat-accordion [multi]="true">
        <mat-expansion-panel
          *ngFor="let cfgForm of roomForm.get('bed_configurations').controls; let ci = index; let cfgCount = count"
          [formGroupName]="ci"
          [expanded]="true"
          [disabled]="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container *ngIf="isMultiRoom" i18n>Bed Configuration</ng-container>
            </mat-panel-title>
            <mat-panel-description class="gap-3" [class.mr-0]="isMultiRoom">
              <div class="flex-fill"></div>
              <button
                class="btn btn-secondary-danger"
                (click)="onDeleteItem(roomForm.get('bed_configurations'), ci)"
                matTooltip="Delete this bed configuration"
                i18n-matTooltip
              >
                <i class="cs-icon cs-icon-trash"></i>
              </button>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <ng-template
            [ngTemplateOutlet]="bedCfgTmpl"
            [ngTemplateOutletContext]="{
              cfgForm: cfgForm,
              isLivingRoom: isLivingRoom(roomForm.get('type').value)
            }"
          ></ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="mt-3" *ngIf="roomForm.get('bed_configurations').length < maxBedConfigurationLimit">
      <button class="btn btn-secondary-info" (click)="onAddBedConfig(roomForm.get('bed_configurations'), true)">
        <i class="far fa-plus"></i>
        <ng-container i18n> Add Bed Configuration </ng-container>
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #monoRoomCfgTmpl let-roomForm="roomForm">
  <ng-container [formGroup]="roomForm">
    <div formArrayName="bed_configurations" class="bg-white rounded border">
      <mat-accordion [multi]="true">
        <mat-expansion-panel
          *ngFor="let cfgForm of roomForm.get('bed_configurations').controls; let ci = index; let cfgCount = count"
          [formGroupName]="ci"
          [expanded]="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container *ngIf="cfgForm.get('is_default_configuration').value" i18n
                >Standard Arrangement</ng-container
              >
              <ng-container *ngIf="!cfgForm.get('is_default_configuration').value" i18n
                >Alternative Arrangement</ng-container
              >
            </mat-panel-title>
            <mat-panel-description class="gap-3">
              <div class="flex-fill"></div>
              <button
                class="btn btn-secondary-danger"
                (click)="onDeleteItem(roomForm.get('bed_configurations'), ci)"
                matTooltip="Delete this alternative arrangement"
                i18n-matTooltip
                *ngIf="!cfgForm.get('is_default_configuration').value"
              >
                <i class="cs-icon cs-icon-trash"></i>
              </button>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <ng-template [ngTemplateOutlet]="bedCfgTmpl" [ngTemplateOutletContext]="{ cfgForm: cfgForm }"></ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="mt-3" *ngIf="roomForm.get('bed_configurations').length < maxBedConfigurationLimit">
      <button class="btn btn-secondary-info" (click)="onAddBedConfig(roomForm.get('bed_configurations'))">
        <i class="far fa-plus"></i>
        <ng-container i18n> Add Alternative Arrangement </ng-container>
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #bedCfgTmpl let-cfgForm="cfgForm" let-isLivingRoom="isLivingRoom">
  <div [formGroup]="cfgForm">
    <div class="row" formArrayName="beds">
      <ng-container
        *ngFor="let bed of cfgForm.get('beds').controls; let bedIdx = index; let bedsCount = count"
        [formGroupName]="bedIdx"
      >
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="bed_type_id" placeholder="Bed Type" i18n-placeholder required>
              <mat-option
                *ngFor="let type of isLivingRoom ? sofaTypeOptions : bedTypeOptions"
                [value]="type.bed_type_id"
                [matTooltip]="type.bed_type_description"
                matTooltipPosition="left"
              >
                {{ type.bed_type_name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="bed.get('bed_type_id').touched && bed.get('bed_type_id').hasError('required')" i18n>
              Bed Type is required
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6 d-flex gap-3">
          <mat-form-field2 class="mat-block">
            <input type="number" matInput formControlName="bed_count" placeholder="Bed Count" i18n-placeholder />
            <mat-error *ngIf="bed.get('bed_count').touched && bed.get('bed_count').hasError('required')" i18n>
              Bed Count is required
            </mat-error>
            <mat-error *ngIf="bed.get('bed_count').hasError('min')" i18n> Bed Count must be greater than 0 </mat-error>
            <mat-error *ngIf="bed.get('bed_count').hasError('max')" i18n> Bed Count must be less than 255 </mat-error>
          </mat-form-field2>
          <button
            class="btn btn-secondary-danger align-input-row-end"
            (click)="onDeleteItem(cfgForm.get('beds'), bedIdx)"
            *ngIf="bedsCount > 1"
            matTooltip="Delete Bed"
            i18n-matTooltip
          >
            <i class="cs-icon cs-icon-trash"></i>
          </button>
        </div>
      </ng-container>
    </div>
    <div class="d-flex">
      <a
        href="javascript:;"
        (click)="onAddBed(cfgForm.get('beds'))"
        *ngIf="cfgForm.get('beds').length < (isLivingRoom ? 1 : maxBedLimit)"
      >
        <i class="far fa-plus"></i>
        <ng-container i18n> Add Bed </ng-container>
      </a>
    </div>
  </div>
</ng-template>
